import { Text, View, StyleSheet, Image as ImagePdf, Font } from '@react-pdf/renderer';

import { pusatCabangActive, pusatAddress, cabang1Address } from "../../../../utils/globalVariables";
import { stringDivider, sqlDateToHumanDate } from "../../../../utils/globalFunctions";

import logoPerusahaan from "../../../../assets/images/lumos_brand_crop_dua.jpg";

import gmail32 from "../../../../assets/images/utils/gmail_32.png";
import ig32 from "../../../../assets/images/utils/ig_32.png";
import wa32 from "../../../../assets/images/utils/wa_32.png";
import web32 from "../../../../assets/images/utils/web_32.png";
// import map32 from "../../../../assets/images/utils/map_32.png";

import calibriBold from "../../../../assets/fonts/calibri-bold.ttf";
import calibriRegular from "../../../../assets/fonts/calibri-regular.ttf";

const styles = StyleSheet.create({
  flexRow: {
    display: 'flex',
    flexDirection: "row",
    flexWrap: "nowrap",
  },
  flexRowSub: {
    flexBasis: 'auto',
    flexGrow: '1',
  },

  containerIconKontak: {
    display: 'flex',
    flexDirection: "row",
    flexWrap: "nowrap",
    alignItems: 'center',
  }
});

Font.register({ family: 'calibri-bold', src: calibriBold });
Font.register({ family: 'calibri-regular', src: calibriRegular });

const ContactInfo = ({ stateImage, stateLabel, stateMarginRight = '8px' }) => {
  return (
    <View style={[styles.containerIconKontak, { marginRight: stateMarginRight }]}>
      <View style={{ marginRight: '2px' }}>
        <ImagePdf src={stateImage} style={{ width: '8px' }} />
      </View>

      <View style={{ lineHeight: 0.85 }}>
        <Text style={{ fontSize: '10px' }} wrap break>{stateLabel}</Text>
      </View>
    </View>
  )
}

const KopDocument = ({
  stateCaption = '',
  stateProjectId,
  stateCustomerName,
  stateCustomerContact,
  stateTanggalNota
}) => {

  return (
    <View style={[styles.flexRow, { marginBottom: '12px' }]}>
      <View style={{ flexBasis: 'auto', width: '60%', maxWidth: '60%' }}>
        <View style={{ marginBottom: '6px' }}>
          <View style={[styles.flexRow, { alignItems: 'center', gap: '12px', width: '100%' }]}>
            <ImagePdf src={logoPerusahaan} style={{ width: '100px' }} />

            <View style={{ width: 160, paddingTop: '6px' }}>
              <View style={styles.flexRow}>
                <View style={{ marginRight: '4px' }}>
                  <Text style={{ fontSize: '10px' }}>Pusat: </Text>
                </View>

                <View style={styles.flexRowSub}>
                  <Text style={{ fontSize: '10px' }}>
                    {pusatAddress}
                  </Text>
                </View>
              </View>

              <View style={styles.flexRow}>
                <View style={{ marginRight: '6px' }}>
                  <Text style={{ fontSize: '10px' }}>Cabang: </Text>
                </View>

                <View style={[styles.flexRowSub]}>
                  <Text style={{ fontSize: '10px' }}>
                    {cabang1Address}
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </View>

        <View style={[styles.flexRow, { marginBottom: '6px' }]}>
          <ContactInfo
            stateImage={wa32}
            stateLabel={pusatCabangActive.noHp.one}
            stateMarginRight="0px"
          />
        </View>

        <View style={[styles.flexRow]}>
          <ContactInfo
            stateImage={ig32}
            stateLabel={pusatCabangActive.instagram}
          />

          <ContactInfo
            stateImage={web32}
            stateLabel={pusatCabangActive.web}
          />

          <ContactInfo
            stateImage={gmail32}
            stateLabel={pusatCabangActive.email}
            stateMarginRight="0px"
          />
        </View>
      </View>

      <View style={{ flexBasis: 'auto', width: '40%', maxWidth: '40%' }}>
        <View style={[styles.flexRow, { justifyContent: 'space-between', marginBottom: '3px' }]}>
          <Text style={{ fontSize: '14px', fontFamily: 'calibri-bold' }}>
            {stateCaption}
          </Text>

          <Text style={{ fontSize: '14px', fontFamily: 'calibri-bold' }}>
            {stringDivider(stateProjectId, [2, 6, 8], '.', ' - ')}
          </Text>
        </View>

        <Text wrap>
          Bandung, {sqlDateToHumanDate({
            stateDate: stateTanggalNota,
            stateWithTime: false,
            stateLang: 'id',
            stateIsShort: false,
            stateDay: false,
            stateDefaultValue: ' - ',
            stateDateType: 'day',
            stateWithSecond: false
          })}
        </Text>

        <Text>
          Kepada Yth, {stateCustomerName ? stateCustomerName : ' - '}
        </Text>

        <Text>
          Telp. {stateCustomerContact ? stateCustomerContact : ' - '}
        </Text>
      </View>
    </View>
  )
}

export default KopDocument;